// components/account/AccountHistoricsModal/components/DocumentsPanel.jsx
import { Accordion, Badge } from 'react-bootstrap';
import { FaFolder, FaFolderOpen, FaList } from 'react-icons/fa';
import DocumentItem from './DocumentItem';

/**
 * Panel des documents - Affiche les documents groupés par container
 */
const DocumentsPanel = ({ 
  documentsByContainer = [],
  onOpenDocument,
  onDownloadDocument 
}) => {
  /**
   * Affiche le nombre total de documents
   */
  const getTotalDocuments = () => {
    return documentsByContainer.reduce((total, container) => total + container.count, 0);
  };

  /**
   * Affiche l'icône de container
   */
  const getContainerIcon = (containerName) => {
    return containerName === 'documents' ? (
      <FaFolder className="text-primary me-2" />
    ) : (
      <FaFolderOpen className="text-info me-2" />
    );
  };

  /**
   * Affiche le label du container
   */
  const getContainerLabel = (containerName) => {
    return containerName === 'documents' ? 'Cash (Dépôts)' : 'Transactions';
  };

  if (documentsByContainer.length === 0) {
    return (
      <div className="card border">
        <div className="card-body text-center py-5">
          <FaList className="text-muted fa-3x mb-3" />
          <h5 className="text-muted mb-2">Aucun document disponible</h5>
          <p className="text-muted mb-0">
            Aucun document de preuve trouvé pour les filtres sélectionnés
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card border">
      <div className="card-header bg-light d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          <FaList className="me-2" />
          Documents de preuve ({getTotalDocuments()})
        </h6>
        <Badge bg="light bg-opacity-10 border-light text-light" text="dark">
          Groupés par type
        </Badge>
      </div>
      
      <div className="card-body p-0">
        <Accordion defaultActiveKey={['0']} alwaysOpen>
          {documentsByContainer.map((containerGroup, index) => (
            <Accordion.Item 
              key={index} 
              eventKey={index.toString()}
              className="border-0"
            >
              <Accordion.Header className="bg-light border-bottom">
                <div className="d-flex align-items-center w-100">
                  {getContainerIcon(containerGroup.container)}
                  <div className="flex-grow-1">
                    <strong>{getContainerLabel(containerGroup.container)}</strong>
                    <Badge bg={containerGroup.container === 'documents' ? 'primary bg-opacity-10 border-primary text-white' : 'info bg-opacity-10 border-info text-info'} 
                           className="ms-2">
                      {containerGroup.count} document(s)
                    </Badge>
                  </div>
                </div>
              </Accordion.Header>
              
              <Accordion.Body className="p-3">
                <div className="row">
                  {containerGroup.documents.map((doc, docIndex) => (
                    <div key={docIndex} className="col-md-6 mb-3">
                      <DocumentItem
                        document={doc}
                        onOpen={() => onOpenDocument && onOpenDocument(doc)}
                        onDownload={() => onDownloadDocument && onDownloadDocument(doc)}
                      />
                    </div>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default DocumentsPanel;